import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Alert } from 'react-bootstrap';
import { FORM_FIELDS, FORM_FILED_SEX } from './formFields';


const ProfileModal = ({ data, show, langList, paymentSystems, clearData, loadData }) => {
  const [showModal, setShowModal] = useState(show);

  const handleClose = () => {
    setShowModal(false);
    clearData();
  }

  const handleLoadClose = () => {
    setShowModal(false);
    loadData();
    clearData();
  }

  let dataItems = [];
  for (const [key, value] of Object.entries(data)) {
    let fieldValue = value;
    if (key === 'lang'){
      const lang = langList.find(i => i.value === Number(value));
      if (lang) fieldValue = lang.label;
    }
    if (key === 'payment_service'){
      const paymentSystem = paymentSystems.find(i => i.value === value);
      if (paymentSystem) fieldValue = paymentSystem.label;
    }
    if (key === 'sex'){
      fieldValue = FORM_FILED_SEX[value];
    }
    dataItems.push(<div><strong>{ FORM_FIELDS[key] }</strong>: { fieldValue }</div>)
  }

  return (
    <>
      <Modal show={ showModal } onHide={ handleClose }>
        <Modal.Header closeButton>
          <Modal.Title>{ gettext('Внимание') }!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{ gettext('В прошлый раз вы не сохранили информацию о себе:') }</p>
          <Alert variant='dark'>{ dataItems }</Alert>
          <p className='font-weight-bold'>{ gettext('Мы сберегли для вас ваши данные. Чтобы их не потерять, не забудьте нажать кнопку "Сохранить" в конце формы.') }</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={ handleLoadClose }>
            { gettext('Понятно') }
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

ProfileModal.PropTypes = {
  data: PropTypes.object,
  show: PropTypes.bool.isRequired,
  langList: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  }),
  paymentSystems: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  }),
  clearData: PropTypes.func.isRequired,
  loadData: PropTypes.func.isRequired,
}

export default ProfileModal;

